import { Fragment, useEffect, useState } from 'react'
import PageHeader from './utils/PageHeader'
import { CardBody, Table } from 'reactstrap'
import { API_URL } from './utils/Constants/URLS'
import { Link } from 'react-router-dom'
const ViewSalesOrder = () => {
  const token = localStorage.getItem('token')
  const [soData, setSoData] = useState([])
  useEffect(() => {
    const fetchSO = async () => {
      try {
        const res = await fetch(
          `${API_URL}leads/sales-orders/approval/requests`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`
            }
          }
        )
        const result = await res.json()
        setSoData(result?.data)
      } catch (e) {
        console.log(e)
      }
    }
    fetchSO()
  }, [token])

  return (
    <Fragment>
      <PageHeader
        pageName='VIEW SO'
        breadcrump1='Home'
        breadcrump2='View SO'
        link='/dashboard'
      />
      <div className='main lg:p-6 xl:p-6 2xl:p-6 sm:p-3 md:p-3 '>
        <CardBody>
          <div className='table-responsive sm:overflow-auto sm:max-h-[400px] w-full  mb-3 '>
            <Table hover className='align-middle table-nowrap'>
              <thead className='table-light'>
                <tr>
                  <th>Lead Details</th>
                  <th>Created By</th>
                  <th>Version</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {soData.map((data, index) => {
                  return (
                    <tr key={index}>
                      <td>
                        <Link
                          className='text-dark no-underline'
                          to={data?.salesOrder?._id}
                        >
                          {data?.salesOrder?.lead?.leadId} |{' '}
                          {data?.salesOrder?.lead?.leadJourneyName}
                        </Link>
                      </td>
                      <td>{data?.createdBy?.name}</td>
                      <td>{data?.salesOrder?.version}</td>
                      <td>
                        {new Date(
                          data?.salesOrder?.dateOfSO
                        ).toLocaleDateString('en-GB', {
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric'
                        })}
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </div>
    </Fragment>
  )
}

export default ViewSalesOrder
